<subscription-page
  [subscription]="subscription()"
  [reportedStatus]="reportedStatus()"
  [isLoading]="isLoading()"
  [isNotFound]="isNotFound()"
  [isNotAuthorized]="isNotAuthorized()"
>
  @if (subscription(); as sub) {
    <aggsp-subscription-view [subscription]="sub" [activities]="activities()" />
  }
</subscription-page>
